module.exports = __webpack_public_path__ + "assets/fonts/iconfont.fb988e64.woff";